import { BrandColors } from "../../../../styles/BrandColors";

export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  stepIcon: {
    borderWidth: 2,
    borderStyle: "solid",
    backgroundColor: BrandColors.JLLBrandColors.Steel.tint50Percent,
    borderColor: BrandColors.JLLBrandColors.Steel.core,
    zIndex: 1,
    width: 20,
    height: 20,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  stepIconActive: {
    backgroundColor: BrandColors.JLLBrandColors.White.core,
    borderColor: BrandColors.JLLBrandColors.Red.core,
  },
  stepIconComplete: {
    backgroundColor: BrandColors.JLLBrandColors.White.core,
    borderColor: BrandColors.JLLBrandColors.Red.core,
  },
  stepIconEnabled: {
    borderColor: BrandColors.JLLBrandColors.Red.core,
  },
  completedIcon: {
    margin: 5,
  },
  stepLabel: {
    cursor: "pointer",
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: BrandColors.JLLBrandColors.Red.core,
  },
  tooltip: {
    fontSize: 12,
    fontWeight: 600,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  multiSelect: {
    maxHeight: 30,
    marginTop: 10,
    marginBottom: 10,
  },
  switchBase: {
    color: "#E30613",
    "&$checked": {
      color: "#E30613",
    },
    "&$checked + $track": {
      backgroundColor: "#E30613",
    },
  },
  checked: {},
  track: {},
  helpText: {
    fontStyle: "italic",
  },
  chipArray: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  docName: {
    borderRadius: 2,
    overflow: "hidden",
    padding: 3,
    textOverflow: "ellipsis",
    marginRight: 3,
  },
});
